<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12">
                <h3>{{ table_title }}</h3>
                <div class="search-form-mask open">
                    <form role="search" method="get" class="form-inline search-form">
                        <div class="form-group">
                            <input v-model.lazy="search" type="search" class="sb-search-input form-control"
                                   placeholder="Search user"/>
                        </div>
                        <div v-if="this.search">
                            <button @click.prevent="reset" type="reset" class="btn-icon btn-light sb-icon-reset">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">Reset</span>
                                </span>
                            </button>
                        </div>
                        <button @click.prevent="getUsers" type="submit" class="btn btn-light sb-icon-search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers"><h4>{{ header }}</h4></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!users.data">
                        <td :colspan="`${table_headers.length}`"><span class="spinner anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!users.data.length">
                        <td :colspan="`${table_headers.length}`">No users found</td>
                    </tr>
                    <tr v-for="user in users.data" v-bind:key="user.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'full_name'">
                                <a :href="`/employees/${user.id}`">{{ user[column] }}</a>
                            </div>
                            <div v-else-if="column === 'company_name'">
                                <a :href="`/companies/${user.company_id}`">{{ user[column] }}</a>
                            </div>
                            <div v-else>
                                {{ user[column] }}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="users" :limit=3 @pagination-change-page="getUsers">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "OfflineAccessForLockDataTable",
    props: {
        api_endpoint: {
            type: String,
        },
        table_title: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            users: {},
            paginate: 10,
            search: "",
        }
    },
    watch: {
        paginate: function (value) {
            this.getUsers();
        },
        search: function search(value) {
            this.getUsers()
        },
    },
    methods: {
        getUsers(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    q: this.search,
                }
            })
            .then(response => {
                this.users = response.data;
            });
        },
        reset() {
            this.search = '';
        }
    },
    mounted() {
        this.getUsers();
    }
}
</script>

